import { render } from "./WorksBlock.vue?vue&type=template&id=185f2358&scoped=true"
const script = {}

import "./WorksBlock.vue?vue&type=style&index=0&id=185f2358&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185f2358"]])

export default __exports__